import { render } from "./SelectVariantModal.vue?vue&type=template&id=d72b89dc"
import script from "./SelectVariantModal.vue?vue&type=script&lang=js"
export * from "./SelectVariantModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/MAR WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__